'use client';
import { styled } from 'styled-components';
import Button from '@/components/atoms/Button';
import ContentText from '@/components/atoms/ContentText';
import Image from 'next/image';
import Link from 'next/link';
import useWidth from '@/util/useWidth';
import { Metadata } from 'next';

export const metadata: Metadata = {
  title: '404 Not found ページが見つかりません | NTH オンライン',
};

export default function NotFound() {
  const { isMobile } = useWidth();
  return (
    <Container>
      <Image
        src="https://bucketeer-7f8bc701-2926-4975-840a-81a00f007653.s3.us-east-1.amazonaws.com/public/not_found_404.webp"
        alt="404 ページが見つかりませんというエラーを伝える画像"
        height={isMobile ? 118 : 237}
        width={isMobile ? 279 : 559}
        className="Image_box"
      />

      <div className="message_box">
        {isMobile ? (
          <>
            <ContentText className="big">
              このURLに該当するページが見つかりません
            </ContentText>
            <ContentText>
              お探しのページは移動もしくは削除された可能性があります
            </ContentText>
          </>
        ) : (
          <>
            <ContentText className="big">
              このURLに該当するページが見つかりません
            </ContentText>
            <ContentText>
              お探しのページは移動もしくは削除された可能性があります
            </ContentText>
          </>
        )}
      </div>
      <Link href={'/'} className="button_box">
        <Button label="TOP画面に戻る"></Button>
      </Link>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 16px;
  .button_box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    text-decoration: none;
  }
  .Image_box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
  }
  .message_box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
    margin-bottom: 40px;
  }
  .big {
    font-size: 25px;
  }
`;
